import { Component, Input } from '@angular/core';
import { ThemeService } from '../../../services/theme.service';

@Component({
    selector: 'loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
})
export class LoadingIndicatorComponent {
    theme: 'light' | 'dark';
    lottiePath: string = '';
    @Input() size: 'small' | 'large' | 'extra-large' | 'extra-small' = 'small';
    constructor(private themeService: ThemeService) {
        this.theme = this.themeService.getTheme();
        this.lottiePath =
            this.theme === 'light' ? 'assets/animations/loading_dark.json' : 'assets/animations/loading.json';
    }
}
